<template>
	<div class="submission-custom-fields">
		<div class="" v-if="!!meta && meta.length > 0">
			<div class="content" :class="{ 'content-full' : showMore }">
				<div class="" v-for="(item, index) in meta" :key="index">
					<div v-if="item.value !== ''">
						<span>{{ item.label }}: </span>
						<span class="ml-1" v-if="isFileUrl(item.value)">
							<a :href="item.value" target="_blank">View file</a>
						</span>
						<span class="ml-1" v-else>{{ item.value }}</span>
					</div>
				</div>
			</div>
			<div v-if="meta.length > 2">
				<button class="btn btn-link btn-tag p-0 text-left" @click="doShowMore"> {{ actionTitle }} </button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		meta: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			showMore: false,
			actionTitle: 'Show More',
		};
	},
	methods: {
		isFileUrl(value) {
			const s3Url = 's3-ap-southeast-1.amazonaws.com';
			return value.includes(s3Url);
		},
		doShowMore() {
			this.showMore = !this.showMore;

			if (this.showMore) {
				this.actionTitle = 'Show Less';
			} else {
				this.actionTitle = 'Show More';
			}
		},
	},
};
</script>

<style scoped>
.submission-custom-fields {
	min-width: 150px;
}

.content {
	height: 45px;
	overflow-y: hidden;
}

.content-full {
	height: auto !important;
	overflow-y: visible;
}
</style>
